import React from 'react';

export type PaginatorProps = {
	defaultNRows?: number;
	nPage?: number;
	setNPage?: React.Dispatch<React.SetStateAction<number>>;
	nRows?: number;
	setNRows?: React.Dispatch<React.SetStateAction<number>>;
	isLoading?: boolean;
	setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>;
};

export interface PaginatorType {
	/** The current page number */
	nPage: number;
	/** Setter for current page number */
	setNPage: React.Dispatch<React.SetStateAction<number>>;
	/** The page rows size */
	nRows: number;
	/** Setter for page rows size */
	setNRows: React.Dispatch<React.SetStateAction<number>>;
	/** The max (total) rows number */
	maxRows: number;
	/** Setter for page rows number */
	setMaxRows: React.Dispatch<React.SetStateAction<number>>;
	/** If true the list is loading */
	isLoading: boolean;
	/** Setter for is loading */
	setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function usePaginator(props?: PaginatorProps) {
	const [nPage, setNPage] = React.useState(1);
	const [nRows, setNRows] = React.useState(props?.defaultNRows || 30);
	const [maxRows, setMaxRows] = React.useState(0);

	const [isLoading, setIsLoading] = React.useState(true);

	return {
		nPage: props?.nPage || nPage,
		setNPage: props?.setNPage || setNPage,
		nRows: props?.nRows || nRows,
		setNRows: props?.setNRows || setNRows,
		maxRows,
		setMaxRows,
		isLoading: props?.isLoading || isLoading,
		setIsLoading: props?.setIsLoading || setIsLoading
	} as PaginatorType;
}
